import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image, Paragraph } from 'components/atoms';
import { getInitials, generateStars } from 'utils/formatting';
import './ReviewCard.scss';

const ReviewCard = ({
	title,
	stars,
	date,
	description,
	user,
	customerImage,
	variant,
}) => (
	<div className={classnames('review-card-container', {
			'review-card-container--search': variant === 'search',
		})}>
		<div className="user-info-container">
			{customerImage ? (
				<div className="outer-circle">
					<Image
						src={customerImage}
						alt={`${user}-portrait-icon`}
					/>
				</div>
			) : (
				<div className="outer-circle">{getInitials(user)}</div>
			)}

			<div className="user-info-text">
				<Paragraph
					size="standardMedium"
					weight="extraBold"
				>
					{user}
				</Paragraph>
				<span className="ss-type-placeholderGray">{date}</span>
				<div className="stars-row"> {generateStars(stars)}</div>
			</div>
		</div>

		<div className="review-text-container">
			<Paragraph
				size="standardMedium"
				weight="extraBold"
			>
				{title}
			</Paragraph>
			<Paragraph>{description}</Paragraph>
		</div>
	</div>
);

ReviewCard.propTypes = {
	title: PropTypes.string,
	stars: PropTypes.number,
	date: PropTypes.string,
	description: PropTypes.string,
	user: PropTypes.string,
	customerImage: PropTypes.string,
	variant: PropTypes.oneOf(['default', 'search']),
};

export default ReviewCard;
